import styled from "styled-components";
import designSystemColors from "../../../../../styles";

export const TextId = styled.span`
  font-family: "Roboto";
  font-weight: "bold";
  font-size: 16px;
  color: ${designSystemColors.backgrounds.lightGray};
`;

export const TextStore = styled.span`
  font-family: "Roboto";
  font-weight: "medium";
  font-size: 12px;
  color: ${designSystemColors.backgrounds.lightGray};
`;

export const DetailCard = styled.div`
  margin-top: 24px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid ${designSystemColors.border.modalDivider};
`;

export const DetailHeader = styled.div`
  background-color: ${designSystemColors.blues.b600};
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
`;

export const DetailContent = styled.div`
  padding: 20px;
  background: white;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 24px;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .highlight {
    color: ${designSystemColors.generalButtons};
  }
`;

export const ItemLabel = styled.label`
  font-size: 12px;
  color: ${designSystemColors.grayTitle};
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ItemText = styled.span`
  font-weight: bold;
  font-size: 14px;
  color: ${designSystemColors.gray700};
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const InstallmentsDescription = styled.span`
  font-weight: 700;
  font-size: 14px;
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
`;
